<div class="d-flex flex-column flex-root " id="kt_login_wrapper">
    <!--begin::Login-->
    <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white" id="kt_login">

        <div class="parent login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden  mx-auto    ">


            <div class="d-flex justify-content-lg-end justify-content-end align-items-end w-100 p-7" >
                <div class="flex-grow-2" >
                    <img src="./assets/media/project-logos/Logo.png" class="max-h-90px cursor-pointer" style="margin-left: 20px;max-height: 60px !important;" alt="" (click)="goToDashboard()"/>
                </div>
                <div class="align-self-center d-flex">

                    <i class="fas fa-bars cursor-pointer listing-margin-r-sm " style="color: darkgray;font-size: 2.5rem; display: flex;
align-self: center; margin-right: 12px"  [matMenuTriggerFor]="menu" ></i>

                    <a [routerLink]="" (click)="endSession()"  class=" highlight -primary ml-10 font-weight-bolder font-size-h5 remove-icon">Logout</a>
                </div>
            </div>




            <mat-menu #menu="matMenu" style="padding: 20px !important;border-radius: 20px">


                <a mat-menu-item routerLink="/" class=" font-weight-bolder font-size-h5 ">My Will</a>
                <a *ngIf="plan != null && plan_paid == true"  mat-menu-item routerLink="/finish" routerLinkActive="active" class=" font-weight-bolder font-size-h5" style="color: #ef8c43">My Plan</a>
                <a *ngIf="plan != null && plan_paid == true" mat-menu-item routerLink="/share" routerLinkActive="active"class=" font-weight-bolder font-size-h5">Invite</a>
                <a *ngIf="plan != null && plan_paid == true" mat-menu-item routerLink="/download" routerLinkActive="active"class=" font-weight-bolder font-size-h5">Download</a>
<!--                <a *ngIf="plan != null && plan_paid == true" mat-menu-item routerLink="/review" routerLinkActive="active"class=" font-weight-bolder font-size-h5">Review  Will</a>-->
                <a  [routerLink]="" (click)="endSession()"  mat-menu-item class=" font-weight-bolder font-size-h5 sm-remove-icon">Logout</a>

            </mat-menu>

            <div class="login-form login-signin">
                <div class="gradient" style="padding-top: 30px; padding-bottom: 80px">
                    <div class="pb-13 pt-lg-0 pt-5">
                        <p class="font-weight-bolder text-dark text-align-center font-heading mt-4" style="font-size: 2.4rem !important;">
                            {{templateText.heading}}</p>

                        <p class="text-align-center font-heading mt-2" style="font-size: 1.6rem !important; color: #8F8F8F; margin-bottom: 0px">
                            {{templateText.subHeading }}
                        </p>

                        <!-- <p class="text-align-center " style="font-size: 1.6rem !important; color: #8F8F8F">
                        </p> -->
                    </div>

                    <div class="d-flex justify-content-center " style="margin-top: 5px">


                        <div class="snip1214  d-flex plan-container">

                            <!-- bronze -->
                            <div class="plan align-self-center " style=" border-bottom-left-radius: 20px; border-top-left-radius: 20px ;padding: 18px">

                                <div class="plan-cost" style="margin-top: 25px"><span class="plan-price " style="color: black ">Bronze</span><span class="plan-type"></span></div>
                                <span class="plan-type"> Our popular free Will plan! Edit
your draft Will until it is published, however no changes can be made once your Will is completed.
</span>

                                <div class="pb-lg-0 pb-5 mt-4 " style="margin-left: auto">
                                    <button type="button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-9 width-150 " (click)="checkoutbronze()" [disabled]="getCtaButtonText(plan, 0) == 'Not Applicable'  || getPlan(plan , 0 )">
                                        {{getCtaButtonText(plan, 0) }}
                                    </button>
                                </div>


                                <div class="plan-cost"><span class="formatted-text theme-color-orange" style="">$69</span><span class="plan-type"></span></div>

                                <div class="division"></div>



                                <ul class="plan-features mt-4 d-flex flex-column">
                                    <li class="align-self-baseline plan-type" style="display: flex;
text-align: initial;"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>WiserNow Will download</li>
                                    <li class="align-self-baseline plan-type " style="display: flex;
text-align: initial;"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>Unlimited draft Will edits</li>
                                    <li class="align-self-baseline plan-type " style="display: flex;
text-align: initial;"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>Will locked once completed </li>


                                    <li class="align-self-baseline " style="display: flex; text-align: initial; opacity: 0"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px; opacity: 0" alt=""/>
                                        Secure storage of Will
                                    </li>
                                    <li class="align-self-baseline " style="display: flex; text-align: initial; opacity: 0"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px; opacity: 0" alt=""/>
                                        Ability to share Will with users outside executors / assign permission to access WiserNow
                                    </li>

                                </ul>

                                <div class="text-align-left" style="opacity: 0; margin-top: 20px;font-size: small">*Donation made to the first charity nominated as an estate beneficiary. Where no charity estate beneficiary is nominated, donation is given to a charity of WiserNow’s choice.</div>


                            </div>
                            <!-- bronze end -->
                            <!-- silver -->
                            <div class="plan featured align-self-center" style="padding: 18px">

                                <button type="button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-9 width-150 " style="margin-top: -3rem !important; border-radius: 20px !important;" >
                                Most Popular
                                </button>

                                <div class="plan-cost silver-p"><span class="plan-price " style="color: black">Silver</span><span class="plan-type"></span></div>
                                <span class=" silver-p">Unlimited edits on your Will,
forever, as well as legal validation
from our specialist Wills team.
</span>

                                <div class="pb-lg-0 pb-5 mt-4 " style="margin-left: auto">
                                    <button (click)="checkoutsilver(plan,1)" type="button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-9 width-150 " [disabled]="getCtaButtonText(plan, 1) == 'Not Applicable' || getPlan(plan , 1 ) ">
                                        {{getCtaButtonText(plan, 1) }}
                                    </button>
                                </div>


                                <div class="plan-cost"><span class="formatted-text theme-color-orange">$149</span><span class="plan-type"></span></div>
                                <span class="" style="color: white;opacity: 0;">$5/month thereafter</span>

                                <div class="division"></div>

                                <ul class="plan-features mt-4">

                                    <li class="align-self-baseline silver-p" style="display: flex; text-align: initial;"><img src="./assets/media/misc/least-silver.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>
                                        All the benefits of the Bronze plan
                                    </li>
                                    <li class="align-self-baseline silver-p" style="display: flex; text-align: initial;"><img src="./assets/media/misc/least-silver.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>
                                        $50 charity donation on your behalf*
                                    </li>
                                    <li class="align-self-baseline silver-p" style="display: flex; text-align: initial;"><img src="./assets/media/misc/least-silver.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>
                                        Edit your Will forever
                                    </li>
                                    <li class="align-self-baseline silver-p" style="display: flex; text-align: initial;"><img src="./assets/media/misc/least-silver.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>
                                        Legal validation and issue identification
                                    </li>

                                </ul>

                                <div class="text-align-left silver-p"  style="margin-top: 20px;font-size: small;">*Donation made to the first charity nominated as an estate beneficiary. Where no charity estate beneficiary is nominated, donation is given to a charity of WiserNow’s choice.</div>


                                <ul class="plan-features mt-4">

                                    <li class="align-self-baseline " style="display: flex; text-align: initial;opacity: 0"><img src="./assets/media/misc/least-silver.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px ;opacity: 0" alt=""/>
                                        Secure storage of Will
                                    </li>
                                    <li class="align-self-baseline " style="display: flex; text-align: initial;opacity: 0"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px;opacity: 0" alt=""/>
                                        Ability to share Will with users outside executors / assign permission to access WiserNow
                                    </li>






                                </ul>


                            </div>
                            <!-- silver end -->
                            <!-- gold -->
                            <div class="plan align-self-center " style=" border-bottom-right-radius: 20px; border-top-right-radius: 20px ;padding: 18px">

                                <div class="plan-cost" style="margin-top: 25px"><span class="plan-price " style="color: black ">Gold</span><span class="plan-type"></span></div>
                                <span class="plan-type">All the benefits of the Silver plan,
with the ability to include
bespoke needs into your Will.
</span>

                                <div class="pb-lg-0 pb-5 mt-4 " style="margin-left: auto">
                                    <button (click)="checkoutGold(plan,2)" type="button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-9 width-150 " [disabled]="getCtaButtonText(plan, 2) == 'Not Applicable'  || getPlan(plan , 2 )">
                                        {{getCtaButtonText(plan, 2) }}
                                    </button>
                                </div>


                                <div class="plan-cost"><span class="formatted-text theme-color-orange" style="">$799</span><span class="plan-type"></span></div>
                                <!-- <span class="" style="color: white;opacity: 0;">$5/month thereafter</span> -->

                                <div class="division"></div>

                                <ul class="plan-features mt-4">


                                    <li class="align-self-baseline plan-type " style="display: flex;text-align: initial;"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>
                                        All the benefits of the Silver plan
                                    </li>
                                    <li class="align-self-baseline plan-type " style="display: flex;text-align: initial;"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>
                                        $50 charity donation on your behalf*
                                    </li>
                                    <li class="align-self-baseline plan-type " style="display: flex;
text-align: initial;"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>Personalised legal consultation</li>

                                    <li class="align-self-baseline plan-type " style="display: flex;
text-align: initial;"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px" alt=""/>Creation of your bespoke Will</li>
                                <!-- <li class="align-self-baseline " style="display: flex; text-align: initial; opacity: 0"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px; opacity: 0" alt=""/>
                                    Secure storage of Will
                                </li> -->

                                </ul>

                                <div class="text-align-left" style="margin-top: 20px;  color: #8F8F8F;font-size: small;">*Donation made to the first charity nominated as an estate beneficiary. Where no charity estate beneficiary is nominated, donation is given to a charity of WiserNow’s choice.</div>


                                <ul class="plan-features mt-4">

                                    <li class="align-self-baseline " style="display: flex; text-align: initial; opacity: 0"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px; opacity: 0" alt=""/>
                                        Secure storage of Will
                                    </li>
                                    <li class="align-self-baseline " style="display: flex; text-align: initial; opacity: 0"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px; opacity: 0" alt=""/>
                                        Secure storage of Will
                                    </li>
                                    <!-- <li class="align-self-baseline " style="display: flex; text-align: initial; opacity: 0"><img src="./assets/media/misc/least.svg" class="max-h-90px " style="max-height: 30px !important; margin-right: 10px; opacity: 0" alt=""/>
                                        Secure storage of Will
                                    </li> -->

                                </ul>

                            </div>
                            <!-- gold end -->

                        </div>

                    </div>
                </div>
                <!-- <div class="d-flex justify-content-center align-content-center mb-15" style="background: white ;"> -->
                <div class="d-flex justify-content-center align-content-center " style="background: white ; margin-bottom: 50px">
                    <img src="./assets/media/misc/vector-big.svg" style=" margin-right: 10px" alt="" class="image-verctor-big max-h"/>

                    <div style="" class="review">

                        <div class="pb-13 pt-lg-0 pt-5">
                            <p class="font-weight-bolder text-dark text-align-center font-heading mt-15" style="font-size: 2.4rem !important;">
                                Review your Will</p>

                            <p class="text-align-center font-heading mt-5" style="font-size: 1.6rem !important; color: #8F8F8F">
                                Review your Will below before completing your Will</p>


                        </div>
                        <img src="./assets/media/misc/vector-right.svg" style=" margin-right: 10px" alt="" class="right-vector "/>

                        <img src="./assets/media/misc/vector-left.svg" style=" margin-right: 10px" alt="" class="left-vector "/>

                        <ngb-accordion #acc="ngbAccordion" closeOthers="true" style="border-radius: 50px " (panelChange)="toggleAccordian($event)">


                            <ng-container *ngFor="let item of processListing; let  index = index">

                                <ngb-panel [id]="item.id" style="background: white !important;border-radius: 50px ;">
                                    <ng-template ngbPanelHeader let-opened="opened" style="border-radius: 50px">
                                        <button ngbPanelToggle style="width: 100%; background: white;font-size: 0 ; border-radius: 50px;padding-bottom: 20px" class="text-left no-border bt">

                                            <div class="d-flex align-items-center  listing-item" [class.collapsed]="!opened" style="background: wheat">
                                                <img  [src]="getIcon(item.id,getFinishedItem(item,processListing, index))"    alt="" title="" style=" border-radius: 15px;object-fit: contain" width="40" height="40">

                                                <div class="form-check form-check-custom form-check-solid mx-5"></div>
                                                <div class="flex-grow-1"><h3 class="listing-text-color text-gray-800 text-hover-primary fw-bolder fs-6 cursor-pointer"> Step {{index + 1 }}:  {{item.label}}</h3></div>

                                                <i class="fas theme-color-orange" style="font-size: 2.0rem" [ngClass]=" expandAccordian(item)? item.chevUp:item.chevDown"> </i>


                                            </div>

                                        </button>
                                    </ng-template>


                                    <ng-template ngbPanelContent>
                                        <app-summary-status [isFinish]="true" *ngIf="index==0"></app-summary-status>
                                        <app-executor-summary [isFinish]="true" *ngIf="index==1"></app-executor-summary>

                                        <app-estate-summary *ngIf="index ==2" [isFinish]="true"></app-estate-summary>
                                        <app-gift-summary [isFinish]="true" *ngIf="index==3"></app-gift-summary>
                                        <app-funeral-summary [isFinish]="true" *ngIf="index==4"></app-funeral-summary>
                                    </ng-template>

                                </ngb-panel>

                            </ng-container>


                        </ngb-accordion>


                    </div>
                </div>
            </div>


            <!--end::Content-->
        </div>
        <!--end::Login-->
    </div>
</div>


<!--<i class="fa fa-check-circle" aria-hidden="true"></i>-->

<div id="payment-element">
    <!-- Elements will create form elements here -->
  </div>
